import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import DialogConfirm from '../../../../../dialog/DialogConfirm';
import usePeriodicalReportSetting from '../../../../../../hooks/periodical-report/usePeriodicalReportSetting';
import { Alert } from '@mui/material';
import FormSpecialCircumstances from './Form';

const SpecialCircumstancesDialog = ({ show, onClose, type, formData = {}, onReset, curriculumList = [] }) => {
  const types = ['create', 'edit', 'delete', 'preview'];
  const { createSubModule, updateSubModule, deleteSubModule } = usePeriodicalReportSetting();
  const [form, setInputForm] = useState(formData);
  const [errors, setInputErrors] = useState(null);
  const [loading, toggleLoading] = useState(false);

  const onChange = (name, value) => {
    setInputForm({ ...form, [name]: value });
    setInputErrors({ ...errors, [name]: null });
  };

  const onSave = async (e) => {
    if (!types.includes(type)) {
      setInputErrors({ message: 'Invalid type' });
      return;
    }
    e.preventDefault();
    toggleLoading(true);
    try {
      let result = { error: false };
      if (type === 'create') {
        result = await createSubModule(form, 'special-circumstances');
      }
      if (type === 'edit') {
        result = await updateSubModule(form._id, 'special-circumstances', form);
      }
      if (type === 'delete') {
        result = await deleteSubModule(form._id, 'special-circumstances');
      }
      if (result.error) {
        setInputErrors(result);
      } else {
        onClose();
        onReset();
      }
    } finally {
      toggleLoading(false);
    }
  };

  return (
    <DialogConfirm
      id={`${type}-special-circumstances`}
      open={show}
      title={`${type} special circumstances`}
      onCancel={onClose}
      onConfirm={['create', 'edit', 'delete'].includes(type) ? onSave : undefined}
      textConfirm={type === 'delete' ? 'Confirm' : 'Save'}
      onCloseHeader={type === 'preview'}
      showActions={['create', 'edit', 'delete'].includes(type)}
      loading={loading}
      maxWidth='xs'
    >
      {types.includes(type) ? (
        <>
          {type === 'delete' ? (
            <Typography component={'div'}>
              Are you sure you want to delete the special circumstances: <b>{form.name}</b>?
            </Typography>
          ) : (
            <div className='flex flex-col gap-4 py-4'>
              <div className='grid grid-cols-4 items-center gap-4'>
                <FormSpecialCircumstances
                  form={form}
                  errors={errors}
                  onChange={onChange}
                  type={type}
                  curriculumList={curriculumList}
                />
              </div>
            </div>
          )}
        </>
      ) : (
        <Alert severity='error'>Invalid type</Alert>
      )}
      {errors && errors.message && (
        <Alert severity='error' onClose={() => setInputErrors({ message: null })}>
          {errors.message}
        </Alert>
      )}
    </DialogConfirm>
  );
};

export default SpecialCircumstancesDialog;
